import { Pipe, PipeTransform } from "@angular/core";
import { AppReferentialResolverService } from "../../services/dictionary/app-referential-resolver.service";

@Pipe({
  name: "hubLabel",
})
export class HubLabelPipe implements PipeTransform {
  constructor(private resolverService: AppReferentialResolverService) {}

  transform(hubId: number | undefined): string | undefined {
    if (hubId === undefined) return hubId;

    const hub = this.resolverService.retrieveHub(hubId);
    return hub?.name ?? "";
  }
}
